import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTASection() {
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal();
  const { ref: subtitleRef, revealed: subtitleRevealed } = useScrollReveal({ delay: 200 });
  const { ref: btnsRef, revealed: btnsRevealed } = useScrollReveal({ delay: 350 });

  return (
    <section id="cta-final" className="relative bg-background-950 overflow-hidden">
      <div className="absolute inset-0 grid-bg pointer-events-none"></div>
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-2xl">
          <h2
            ref={titleRef}
            className={`font-display font-extrabold text-[40px] md:text-[56px] leading-[1.05] tracking-tightest text-background-50 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Подключите AIGAM и начните получать готовые сделки
          </h2>
          <p
            ref={subtitleRef}
            className={`mt-6 text-[17px] md:text-[19px] text-background-50/60 leading-relaxed max-w-lg reveal-fade-up ${subtitleRevealed ? 'revealed' : ''}`}
          >
            Без сложной настройки. Без долгого обучения. Система работает сразу после подключения. Первые заявки — в течение 24 часов.
          </p>
          <div
            ref={btnsRef}
            className={`mt-8 flex flex-col sm:flex-row items-start gap-3 reveal-fade-up ${btnsRevealed ? 'revealed' : ''}`}
          >
            <Link
              to="/telegram-leads"
              className="h-12 px-7 inline-flex items-center justify-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Подключить AIGAM
              <i className="ri-arrow-right-line ml-2 text-lg"></i>
            </Link>
            <a
              href="#demo-form"
              className="h-12 px-6 inline-flex items-center justify-center rounded-md border border-background-50/20 hover:border-background-50/40 text-background-50/80 text-[15px] font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Получить демо
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}